import {Realm} from "../environment/realm/realm";

export function $Int32ArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Int32Array.prototype;
}
